//@ts-check
import React from "react"
import { useTranslation } from "react-i18next"

import { CircularProgress } from "@material-ui/core"
import Button from "./button"
import useStyles from "./styles"
import { SCR_APP_URLS } from "shared/consts";

export default ({ onClick }) => {
  const classes = useStyles({})
  const { t } = useTranslation()

  let description = t("scanning");

  if(location.pathname.match( SCR_APP_URLS.simplifier)){
    description = t("simplifying");
  }


  return (
    <div className={classes.loaderContainer}>
      <div className={classes.scanLoaderContainer}>
        <span className={classes.scanLoaderContainerTitle}>
          {description}...
        </span>
        <CircularProgress color="primary" />
        <Button
          onClick={onClick}
          variant="outlined"
          color="primary"
          size="small"
        >
          {t("cancel")}
        </Button>
      </div>
    </div>
  )
}
